import React from 'react'
import { MissingScopeAction } from '../../../../../components/ScopedBlock/models'
import { Stack } from 'react-bootstrap'
import { ScopedBlock } from '../../../../../components/ScopedBlock/ScopedBlock'
import PrizeBadge from '../../../../../components/ScopedBlock/PrizeBadge.svg?url'
import { MultiSelectDropdown, MultiSelectOption } from '../../../../../components/MultiSelectDropdown/MultiSelectDropdown'

export interface UserFilterProps {
  sessionSharingAvailable: boolean
  userFilterValues: MultiSelectOption[]
  selectedUserIds: string[]
  disabled?: boolean
  onSelectedChanged: (ids: string[]) => void
}

export const UserFilter: React.FC<UserFilterProps> = ({ userFilterValues, selectedUserIds, sessionSharingAvailable, disabled, onSelectedChanged }) => {
  return (
    <Stack>
      <div className='d-flex mb-1'>
        <div className='text-nowrap'>Filter by team members ({selectedUserIds.length})</div>
        {!sessionSharingAvailable ? <img alt='Upgrade' src={PrizeBadge} /> : null}
      </div>

      <ScopedBlock
        quota={{
          quota: 'identity.sessionSharingEnabled.value',
        }}
        missingScopeAction={MissingScopeAction.UPGRADE}
        showUpgradeBadge={false}
      >
        <MultiSelectDropdown
          name='userIds'
          options={userFilterValues}
          initialSelectedOptions={selectedUserIds}
          onSelectedChanged={onSelectedChanged}
          disabled={disabled}
        />
      </ScopedBlock>
    </Stack>
  )
}
